import { AlertTriangle, CheckCircle2, XCircle } from "lucide-react";

import { t } from "@/i18n/pl";
import { cn } from "@/lib/utils";
import type { DayStatus } from "@/types/api";

/**
 * The unmissable "how is my ride today" strip. Color is the message:
 * green = as planned, amber = later, red = not driving.
 */
export function DayStatusBanner({
  status,
  className,
}: {
  status: DayStatus;
  className?: string;
}) {
  const config = {
    on_time: {
      icon: CheckCircle2,
      label: t.status.onTime,
      classes: "bg-[oklch(0.94_0.05_124)] text-[oklch(0.35_0.09_124)]",
    },
    delayed: {
      icon: AlertTriangle,
      label: t.status.delayed(status.delay_minutes ?? 0),
      classes: "bg-[oklch(0.95_0.05_85)] text-[oklch(0.4_0.09_60)]",
    },
    cancelled: {
      icon: XCircle,
      label: t.status.cancelled,
      classes: "bg-[oklch(0.93_0.06_26)] text-[oklch(0.4_0.14_26)]",
    },
  }[status.status];

  const Icon = config.icon;

  return (
    <div
      role="status"
      className={cn(
        "animate-in fade-in slide-in-from-top-2 flex items-center gap-2.5 rounded-lg px-4 py-3 text-sm font-semibold duration-300",
        config.classes,
        className,
      )}
    >
      <Icon className="size-4.5 shrink-0" aria-hidden />
      <span>
        {config.label}
        {status.note && <span className="font-normal"> — {status.note}</span>}
      </span>
    </div>
  );
}
